export const MAKE_TYPE = 'make';
export const MODEL_TYPE = 'model';
export const YEAR_START_TYPE = 'minYear';
export const YEAR_END_TYPE = 'maxYear';
export const REGION_TYPE = 'region';
export const VEHICLE_TYPE = 'vehicleType';
export const SUB_MODEL_TYPE = 'subModel';
